/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ResolveCreatorLoginTargetResponse, ResolveCreatorLoginTargetVars } from '../openapi-types.gen.js';

export type { ResolveCreatorLoginTargetResponse, ResolveCreatorLoginTargetVars } from '../openapi-types.gen.js';

export const useResolveCreatorLoginTarget = createMutationHook<ResolveCreatorLoginTargetVars, ResolveCreatorLoginTargetResponse, unknown>({
  specName: 'useResolveCreatorLoginTarget',
  path: '/v1/creators/login-target',
  method: 'POST',
  resolveUrl: (vars: ResolveCreatorLoginTargetVars) => `/v1/creators/login-target`,
  buildBody: (vars: ResolveCreatorLoginTargetVars) => ({ email: vars.email }),
  parseResponse: (raw: unknown): ResolveCreatorLoginTargetResponse => raw as ResolveCreatorLoginTargetResponse,
  
  
  
});
